import { Link } from "react-router-dom";
import { heroBanner, mangaWorks } from "@/mocks/manga";

const fitnessCoach = mangaWorks.find((w) => w.id === "fitness-coach") ?? mangaWorks[0];

export default function Hero() {
  return (
    <section className="relative flex min-h-[520px] w-full items-center justify-center overflow-hidden md:min-h-[620px]">
      <img
        src={heroBanner}
        alt="《健身教练》漫画免费阅读横幅"
        title="《健身教练》漫画免费阅读"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/75 via-background-950/45 to-background-950/80"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-16 text-center md:px-6 md:py-24">
        <span className="anim-fade-up inline-flex items-center gap-1.5 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs font-bold text-background-50 backdrop-blur-sm">
          <i className="ri-fire-fill text-accent-500"></i>
          免费阅读 · 高清全集 · 每日更新
        </span>
        <h1 className="anim-fade-up mt-5 font-heading text-3xl font-black leading-snug text-background-50 md:text-5xl" style={{ animationDelay: "0.1s" }}>
          《健身教练》漫画全集免费阅读
        </h1>
        <p className="anim-fade-up mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-background-50/85 md:text-base" style={{ animationDelay: "0.2s" }}>
          在43423漫画网免费阅读《健身教练》漫画全集，在线浏览全集中文故事，无需付费即可享受完整章节和高清画面。从菜鸟到型男，跟着主角一起流汗蜕变！
        </p>
        <div className="anim-fade-up mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row" style={{ animationDelay: "0.3s" }}>
          <Link
            to={`/reader/${fitnessCoach.id}/1`}
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-8 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-book-open-line mr-2 text-base"></i>
            立即开始阅读
          </Link>
          <Link
            to="/category/all"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-8 py-3 text-sm font-bold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 sm:w-auto"
          >
            浏览全部漫画
          </Link>
        </div>

        <dl className="anim-fade-up mx-auto mt-10 grid max-w-xl grid-cols-3 gap-3 md:gap-4" style={{ animationDelay: "0.4s" }}>
          <div className="rounded-lg border border-background-50/20 bg-background-50/10 px-3 py-3 backdrop-blur-sm">
            <dt className="text-[11px] text-background-50/70 md:text-xs">全本话数</dt>
            <dd className="mt-1 font-comic text-xl font-bold text-accent-500 md:text-2xl">{fitnessCoach.totalChapters}话</dd>
          </div>
          <div className="rounded-lg border border-background-50/20 bg-background-50/10 px-3 py-3 backdrop-blur-sm">
            <dt className="text-[11px] text-background-50/70 md:text-xs">读者评分</dt>
            <dd className="mt-1 font-comic text-xl font-bold text-accent-500 md:text-2xl">{fitnessCoach.rating.toFixed(1)}分</dd>
          </div>
          <div className="rounded-lg border border-background-50/20 bg-background-50/10 px-3 py-3 backdrop-blur-sm">
            <dt className="text-[11px] text-background-50/70 md:text-xs">站内人气</dt>
            <dd className="mt-1 font-comic text-xl font-bold text-accent-500 md:text-2xl">{fitnessCoach.views}</dd>
          </div>
        </dl>
      </div>
    </section>
  );
}